module.exports = __webpack_public_path__ + "static/img/noData2.049f8c82.png";